<mat-progress-bar color="primary" />

<div
  class="payment-control-container"
  fxLayoutAlign="stretch stretch"
  *ngIf="isReady"
  fxLayout="row"
>
  <div
    id="sidenav"
    fxFlex="30"
    class="mat-elevation-z2"
    fxLayout="space-between center"
  >
    <button class="close app-icon-btn" (click)="closeDialogBox()">
      <jam-icon vertical-align="middle" name="close" />
    </button>

    <div class="actions" fxLayout="column" fxLayoutAlign="start center">
      <button
        (click)="downloadZip.click()"
        class="download-all"
        mat-stroked-button
      >
        دریافت همه فایل‌ها
        <jam-icon vertical-align="middle" name="download" />
        <a [href]="getZipDownloadLink()" #downloadZip></a>
      </button>
      <button
        mat-flat-button
        (click)="updatePostalTrackingCode()"
        *ngIf="nextStatus === paymentStatuses.Sent"
        [color]="data.payment.postTrackingCode ? 'accent' : 'primary'"
      >
        <span *ngIf="!data.payment.postTrackingCode">ثبت</span>
        <span *ngIf="data.payment.postTrackingCode">ویرایش</span> کد پیگیری پستی
        <jam-icon vertical-align="middle" name="qr-code" />
      </button>
      <div class="error-report" fxLayout="column" fxLayoutAlign="start center">
        <h2>اعلام خطا</h2>
        <mat-form-field appearance="outline">
          <mat-label>نوع خطا</mat-label>
          <mat-select matNativeControl [(ngModel)]="selectedType">
            <mat-option value="FILE_BROKEN">
              {{ paymentErrors.FILE_BROKEN }}
            </mat-option>
            <mat-option value="INFORMATION_FALSY">
              {{ paymentErrors.INFORMATION_FALSY }}
            </mat-option>
            <mat-option value="NOT_PROCESSABLE">
              {{ paymentErrors.NOT_PROCESSABLE }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" id="errorTextarea">
          <textarea #errorMessage matInput id="errorMessage"></textarea>
        </mat-form-field>

        <button
          mat-stroked-button
          color="warn"
          (click)="addError(errorMessage.value)"
        >
          اعلام خطا
          <jam-icon name="triangle-danger" vertical-align="middle"></jam-icon>
        </button>
      </div>
    </div>

    <div class="status">
      وضعیت:
      <span style="color: var(--primary); font-weight: bolder">{{
        currentStatusPersianWord
      }}</span>
    </div>
  </div>
  <div id="wrapper" fxFlex="70">
    <mat-tab-group animationDuration="0ms" fxFlex="100">
      <!-- Information -->
      <mat-tab label="اطلاعات">
        <div class="main-holder" id="information-tab" fxFlex="100">
          <div class="section-title-group">
            <span style="margin-left: 10px"
              ><strong>اطلاعات سبد خرید</strong></span
            >
            <span class="disabled">تمامی اطلاعات مهم مربوط به سبد سفارش</span>
          </div>

          <section class="payment-information">
            <div
              class="info-blocks"
              fxLayout="row wrap"
              fxLayoutAlign="space-around stretch"
            >
              <div
                class="info-block"
                fxFlex="45"
                fxFlex.lt-sm="100"
                fxLayout="column"
              >
                <jam-icon
                  vertical-align="middle"
                  class="user-icon"
                  [size]="100"
                  name="user"
                ></jam-icon>
                <div
                  class="block"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                >
                  <div class="title" fxFlex="50">شماره کاربری</div>
                  <div class="data" fxFlex="50" dir="ltr">
                    {{ data.payment.user?.id! }}
                  </div>
                </div>

                <div
                  class="block"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                >
                  <div class="title" fxFlex="50">نام کاربری</div>
                  <div class="data" fxFlex="50">
                    {{ data.payment.user?.fullName }}
                  </div>
                </div>

                <div
                  class="block"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                >
                  <div class="title" fxFlex="50">تلفن یا ایمیل</div>
                  <div class="data" fxFlex="50">
                    {{ data.payment.user?.phone || data.payment.user?.email }}
                  </div>
                </div>
              </div>

              <div
                class="info-block"
                fxFlex="45"
                fxFlex.lt-sm="100"
                fxLayout="column"
              >
                <jam-icon
                  vertical-align="middle"
                  class="user-icon"
                  [size]="100"
                  name="coin"
                ></jam-icon>
                <div
                  class="block"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                >
                  <div class="title" fxFlex="50">مبلغ سفارش</div>
                  <div class="data" fxFlex="50" dir="ltr">
                    {{
                      data.payment.amount!.toString() | irc : "T" | digitsEnToFa
                    }}
                  </div>
                </div>

                <div
                  class="block"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                >
                  <div class="title" fxFlex="50">نحوه پرداخت</div>
                  <div class="data" fxFlex="50">{{ "اینترنتی" }}</div>
                </div>

                <div
                  class="block"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                >
                  <div class="title" fxFlex="50">کد پیگیری</div>
                  <div class="data" fxFlex="50">
                    {{ data.payment.hash }}
                  </div>
                </div>
              </div>
            </div>
            <div class="preview-pages"></div>
            <div class="description"></div>
          </section>

          <mat-chip-listbox *ngIf="data.payment.postTrackingCode">
            <div class="wrapper" style="padding: 30px">
              کد پیگیری پست
              <mat-chip> {{ data.payment.postTrackingCode }}</mat-chip>
            </div>
          </mat-chip-listbox>

          <mat-divider></mat-divider>

          <!------------------------- Status Change Section -->

          <div
            [class.disabled]="currentStatus === paymentStatuses.Sent"
            class="section-title-group"
          >
            <span style="margin-left: 10px"
              ><strong>رفتن به مرحله بعد</strong></span
            >
            <span class="disabled"
              >نیاز است تمامی موارد سفارش برای رفتن به مرحله بعد محیا باشد.
            </span>

            <div
              class="errors"
              *ngIf="
                !nextStatusProceedValidation.ok &&
                nextStatusProceedValidation?.error
              "
            >
              <ul>
                <li>
                  <span style="color: var(--warn)">{{
                    nextStatusProceedValidation.error
                  }}</span>
                </li>
              </ul>
            </div>

            <section class="change-status-sec">
              <button
                (click)="updateStatusToNext()"
                [disabled]="
                  !this.nextStatusProceedValidation.ok || updateStatusLoading
                "
                color="primary"
                style="margin-right: 10px"
                mat-flat-button
              >
                رفتن به مرحله بعد ( {{ nextStatusPersianWord }} )
                <jam-icon
                  vertical-align="middle"
                  name="chevron-left"
                  *ngIf="!updateStatusLoading"
                ></jam-icon>
                <jam-icon
                  *ngIf="updateStatusLoading"
                  name="hourglass"
                  class="rotating"
                  vertical-align="middle"
                ></jam-icon>
              </button>
            </section>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="سفارشات">
        <div class="main-holder" id="information-tab" fxFlex="100">
          <mat-accordion *ngFor="let order of ordersInfo">
            <h1 class="panel-title" *ngIf="order?.type === 'print'">پرینت ساده</h1>
            <h1 class="panel-title" *ngIf="order?.type === 'thesis'">
              پرینت پایان‌نامه
            </h1>
            <h1 class="panel-title" *ngIf="order?.type === 'thesis-edit'">
              ویرایش پایان‌نامه
            </h1>
            <mat-expansion-panel
              *ngFor="let info of ordersInfo; index as i"
            >
              <mat-expansion-panel-header
                [class.done]="info?.status === 'done'"
                [class.need-action]="info?.status !== 'done'"
              >
                <mat-panel-title>
                  {{ info?.type }} ({{
                    info?.status === "done" ? "انجام شده" : "انجام نشده"
                  }})
                </mat-panel-title>
                <mat-panel-description>
                  <div
                    class="order-summery"
                    fxLayout="row"
                    fxFlex="100"
                    fxLayoutAlign="space-between center"
                  >
                    <span class="info">
                      <span class="data"
                        >تعداد صفحه:‌ {{ info?.pageCount }}</span
                      > | <span class="data">تعداد نسخه: {{ info?.copiesNumber }}</span
                      > |
                      <span class="data">صحافی: بدون صحافی</span>
                    </span>
                    <span class="hash">
                      کد سفارش: {{ info?.hash }}</span
                    >
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="actions" fxLayout="row" fxLayoutAlign="start center">
                <button
                  [disabled]="
                    this.currentStatus !== paymentStatuses.Implementation ||
                    info?.status === 'done'
                  "
                  mat-flat-button
                  color="primary"
                  fxLayout="row"
                >
                <!-- (click)="markOrderAsDone(info!, type, i)" -->
                  <span>انجام شده</span>
                  <jam-icon
                    *ngIf="!this.updateStatusLoading"
                    name="check"
                  ></jam-icon>
                  <jam-icon
                    *ngIf="this.updateStatusLoading"
                    class="rotating"
                    name="hourglass"
                  ></jam-icon>
                </button>
                <button
                  [disabled]="
                    this.currentStatus !== paymentStatuses.Implementation ||
                    info?.status === 'progress'
                  "
                  mat-flat-button
                  color="warn"
                  fxLayout="row"
                >
                <!-- (click)="markOrderAsUndone(info!, type, i)" -->

                  <span>انجام نشده</span>
                  <jam-icon
                    *ngIf="!this.updateStatusLoading"
                    name="close"
                    vertical-align="middle"
                  ></jam-icon>
                  <jam-icon
                    *ngIf="this.updateStatusLoading"
                    class="rotating"
                    name="hourglass"
                  ></jam-icon>
                </button>
                <button
                  mat-flat-button
                  color="primary"
                >
                <!-- (click)="generateOrderFactor(info!)" -->
                  <jam-icon name="printer"></jam-icon> دانلود فاکتور
                </button>
              </div>

              <mat-divider></mat-divider>
              <h3 *ngIf="info?.images?.length! > 0">عکس‌ها:</h3>

              <div
                class="image-viewer-wrapper"
                fxLayout="row"
                fxLayoutAlign="space-evenly center"
                ngxViewer
                *ngIf="info?.images?.length! > 0"
              >
                <app-image
                  *ngFor="let img of info?.images"
                  [imageId]="img.id.toString()"
                  [alt]="img.caption"
                  [name]="
                    img.fieldName === 'coverImage' ? 'عکس کاور' : 'امضای استاد'
                  "
                ></app-image>
              </div>
              <div
                class="info-blocks"
                fxLayout="column"
                fxLayout.gt-md="row"
                fxLayoutAlign="space-between start"
              >
                <div
                  fxFlex="100"
                  class="info-block"
                  fxFlex.gt-md="48"
                  fxLayout="column"
                >
                  <jam-icon
                    class="user-icon"
                    [size]="100"
                    name="printer"
                  />
                  <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="50">اندازه کاغذ</div>
                    <div class="data" fxFlex="50">
                      {{ "unknown" }}
                    </div>
                  </div>

                  <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="50">نوع چاپ</div>
                    <div class="data" fxFlex="50">{{ info?.type }}</div>
                  </div>

                  <!-- <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="50">یک رو / دو رو</div>
                    <div class="data" fxFlex="50">
                      {{ info?.side }}
                    </div>
                  </div> -->

                  <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="50">تعداد صفحات</div>
                    <div class="data" fxFlex="50">
                      {{ info?.pageCount }}
                    </div>
                  </div>

                  <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="50">صحافی یا کاور</div>
                    <div class="data" fxFlex="50">
                      {{ info?.binding }}
                    </div>
                  </div>

                  <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="50">رنگ طلق</div>
                    <div class="data" fxFlex="50">
                      {{ info?.talcColor || "---" }}
                    </div>
                  </div>

                  <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="50">تعداد نسخه</div>
                    <div class="data" fxFlex="50">
                      {{ info?.copiesNumber }}
                    </div>
                  </div>
                </div>
                <div
                  fxFlex="100"
                  class="info-block"
                  fxFlex.gt-md="48"
                  fxLayout="column"
                >
                  <jam-icon
                    class="user-icon"
                    [size]="100"
                    name="layers-f"
                  />
                  <!-- <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="20">رنگی</div>
                    <div class="data" fxFlex="75" dir="ltr">
                      <mat-chip-listbox
                        *ngIf="info && (info.ranges['c'] || []).length > 0"
                      >
                        <mat-chip
                          class="range-item"
                          *ngFor="let range of info.ranges['c']"
                        >
                          {{ range }}
                        </mat-chip>
                      </mat-chip-listbox>
                      <span *ngIf="info && (info.ranges['c'] || []).length <= 0"
                        >-</span
                      >
                    </div>
                  </div> -->

                  <!-- <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="20">نیمه رنگی</div>
                    <div class="data" fxFlex="75">
                      <mat-chip-listbox
                        *ngIf="info && (info.ranges['hc'] || []).length > 0"
                      >
                        <mat-chip
                          class="range-item"
                          *ngFor="let range of info.ranges['hc']"
                        >
                          {{ range }}
                        </mat-chip>
                      </mat-chip-listbox>
                      <span
                        *ngIf="info && (info.ranges['hc'] || []).length <= 0"
                        >-</span
                      >
                    </div>
                  </div> -->

                  <!-- <div
                    class="block"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div class="title" fxFlex="20">سیاه و سفید</div>
                    <div class="data" fxFlex="75">
                      <mat-chip-listbox
                        *ngIf="info && (info.ranges['bw'] || []).length > 0"
                      >
                        <mat-chip
                          class="range-item"
                          *ngFor="let range of info.ranges['bw']"
                        >
                          {{ range }}
                        </mat-chip>
                      </mat-chip-listbox>
                      <span
                        *ngIf="info && (info.ranges['bw'] || []).length <= 0"
                        >-</span
                      >
                    </div>
                  </div> -->
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
